import { FaUserCheck, FaUserTimes, FaUserPlus } from "react-icons/fa";
import {
  acceptFriendRequest,
  declineFriendRequest,
  sendFriendRequest,
  cancelFriendRequest,
  unfriendUser,
} from "../../redux/friend/friendAction";

export const GOLD_BTN = "bg-customGold text-black hover:bg-amber-500";
export const GRAY_BTN = "bg-customGray text-white hover:bg-gray-600";

// Drives the "Friend Requests" card everywhere it appears (navbar dropdown,
// the full Friends tab). A handled request stays visible with its new
// status instead of disappearing immediately, so a misclick can be
// corrected: accepted -> Unfriend, declined -> Resend, resent -> Cancel.
export const ACTIONS_BY_STATUS = {
  pending: [
    { action: "accept", label: "Accept", icon: FaUserCheck, className: GOLD_BTN, thunk: acceptFriendRequest, loadingLabel: "Accepting..." },
    { action: "decline", label: "Decline", icon: FaUserTimes, className: GRAY_BTN, thunk: declineFriendRequest, loadingLabel: "Declining..." },
  ],
  accepted: [
    { action: "unfriend", label: "Unfriend", icon: FaUserTimes, className: GRAY_BTN, thunk: unfriendUser, loadingLabel: "Removing..." },
  ],
  declined: [
    { action: "resend", label: "Send Request", icon: FaUserPlus, className: GOLD_BTN, thunk: sendFriendRequest, loadingLabel: "Sending..." },
  ],
  "request-sent": [
    { action: "cancel", label: "Cancel Request", icon: FaUserTimes, className: GRAY_BTN, thunk: cancelFriendRequest, loadingLabel: "Cancelling..." },
  ],
};

export const STATUS_NOTE = {
  accepted: "You're now friends",
  declined: "Request declined",
  "request-sent": "Friend request sent",
};
